import React from 'react';

export const Footer = () => (
    <footer className="main-footer">
      &copy; 2018 <a href="http://www.antikode.com" target="_blank">Antikode</a>. All rights reserved.
    </footer>
);


// WEBPACK FOOTER //
// ./src/components/common/Footer.jsx